import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

// Plans ordered from the lowest to the highest tier.
const PLAN_TIERS = ['BASIC', 'PLUS', 'PRO'];

// True when the plan is the given tier or above. No subscription counts as below every tier.
export function hasPlanAtLeast(subscription, minimumPlan) {
  const tier = PLAN_TIERS.indexOf(subscription?.plan);
  return tier !== -1 && tier >= PLAN_TIERS.indexOf(minimumPlan);
}

// Active subscription (plan) of the logged clinic. Resolves to null when the clinic has none (204).
export function useTenantSubscription() {
  const navigate = useNavigate();

  const fetchSubscription = useCallback(
    () =>
      quarkusApi
        .get('/subscriptions/current', {
          headers: { Authorization: sessionStorage.getItem('token') },
        })
        .then((returnFromApi) => returnFromApi.data || null)
        .catch((returnFromApi) => {
          if (returnFromApi.status === 401) {
            navigate('/expired-session');
          }
          throw returnFromApi;
        }),
    [navigate],
  );

  return { fetchSubscription };
}
